import { MenuItem, Text } from '@chakra-ui/react';
import Dialog from 'components/Dialog';
import showMessage from 'providers/NoticeProvider/showMessage';
import { useState } from 'react';
import { LuTrash2 } from 'react-icons/lu';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes';
import { useAppDispatch } from 'store/hooks';
import { deleteTeam, fetchTeams } from 'store/slices/teams';

type TProps = {
    title: string;
    id: string;
};

const DeleteTeamDialog = ({ title, id }: TProps) => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);

    const handleSubmit = () => {
        try {
            setLoading(true);
            dispatch(deleteTeam({ id }))
                .unwrap()
                .then(() => {
                    showMessage('The team has been successfully deleted.');
                    if (slug) {
                        navigate(ROUTES.team.fullPath);
                    } else {
                        dispatch(fetchTeams());
                    }
                })
                .catch(error => {
                    console.log(error);
                    showMessage('Ooops', 'error');
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (e) {
            return false;
        }
    };
    return (
        <Dialog
            title="Delete team"
            trigger={
                <MenuItem color="red.500" icon={<LuTrash2 />}>
                    Delete team
                </MenuItem>
            }
            submitText="Delete team"
            onSubmit={handleSubmit}
            danger
            loading={loading}
        >
            <div>
                <Text color="gray.500" fontSize="16px" fontWeight={500} lineHeight={1.5} mb="24px">
                    Are you sure you want to delete the team{' '}
                    <Text color="gray.900" as="span">
                        {title}
                    </Text>
                    ?
                </Text>
                <Text color="red.500" fontSize="16px" fontWeight={500} lineHeight={1.5}>
                    Warning! This action cannot be undone.
                </Text>
            </div>
        </Dialog>
    );
};

export default DeleteTeamDialog;
